import React from "react";
import {
	FLEX_SPACER_CLASS,
	INTERACTIVE_CLASSES,
} from "../../interactive-product-classes.js";
import { useInteractiveProductsSettings } from "../context/interactive-product-context.jsx";
import { LikeProductButton } from "./buttons/like-button/LikeProductButton.jsx";
import { ZoomButton } from "./buttons/zoom-button/ZoomButton.jsx";
import { InteractiveLinkButton } from "./InteractiveLinkButton.jsx";
import { useShowingAllZones } from "../../show-all-zones/show-all-zones.jsx";
import { ShoppingCartButton } from "./buttons/cart-button/ShoppingCartButton.jsx";

export const InteractiveHoverElement = ({
	productUid,
	followingRequestBody,
	bottomButtonText,
	buttonLink,
}) => {
	const { disableFollowButton, shoppingCartUrl } =
		useInteractiveProductsSettings();

	const { showingAllZones } = useShowingAllZones();

	// Při zobrazení všech zón zobrazujeme osekanou
	// verzi komponenty.
	const showingSimplifiedVersion = showingAllZones;

	const topElementJSX = (
		<div className={INTERACTIVE_CLASSES.TOP_ELEMENT}>
			<div className={INTERACTIVE_CLASSES.TOP_ICON_ROW}>
				<div className={INTERACTIVE_CLASSES.TOP_ICON_ROW_SECTION}>
					{!disableFollowButton ? (
						<LikeProductButton
							productUid={productUid}
							followingRequestBody={followingRequestBody}
						/>
					) : null}

					{shoppingCartUrl ? (
						<ShoppingCartButton href={shoppingCartUrl} />
					) : null}
				</div>

				<div className={FLEX_SPACER_CLASS} />

				<div className={INTERACTIVE_CLASSES.TOP_ICON_ROW_SECTION}>
					<ZoomButton />
				</div>
			</div>
		</div>
	);

	const bottomElementJSX = (
		<div className={INTERACTIVE_CLASSES.BOTTOM_ELEMENT}>
			<div className={INTERACTIVE_CLASSES.CENTER_ROW}>
				<InteractiveLinkButton
					buttonText={bottomButtonText}
					buttonLink={buttonLink}
					stopLinkPropagation
				/>
			</div>
		</div>
	);

	return (
		<div className={INTERACTIVE_CLASSES.HOVER_ELEMENT}>
			{!showingSimplifiedVersion ? (
				<>
					{topElementJSX}
					{bottomElementJSX}
				</>
			) : null}
		</div>
	);
};
